"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonDetailTag = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledButtonDetailTag = styled_1.default.span `
	color: #ffffff;
	background-color:${props => props.backgroundColor};
	padding: 4px;
	border-radius: 4px;
	font-size: 0.625rem;
	margin-left: 10px;
`;
const ButtonDetailTag = ({ text, backgroundColor }) => {
    return (react_1.default.createElement(StyledButtonDetailTag, { backgroundColor: backgroundColor }, text));
};
exports.ButtonDetailTag = ButtonDetailTag;
//# sourceMappingURL=ButtonDetailTag.js.map